interface Carousel {
  wrapperSelector: string
  itemsSelector: string
  itemSelector: string
  leftCursorSelector: string
  rightCursorSelector: string
  visibleItem: number
  gap: number
}

const HIDDEN_STYLE_CLASS = 'is-hide'
const DISABLED_STYLE = 'color: #ccc; pointer-events: none;'

export function carousel(params: Carousel) {
  const { wrapperSelector, itemsSelector, itemSelector, leftCursorSelector, rightCursorSelector, visibleItem, gap } = params
  const carouselWrapper = document.querySelectorAll<HTMLElement>(wrapperSelector)
  if (carouselWrapper.length === 0) return

  carouselWrapper.forEach((el) => {
    const carouselItems = el.querySelector<HTMLElement>(itemsSelector)
    const carouselItem = el.querySelectorAll<HTMLElement>(itemSelector)
    const leftCursor = el.querySelector<HTMLElement>(leftCursorSelector)
    const rightCursor = el.querySelector<HTMLElement>(rightCursorSelector)

    const ITEM_OUTER_WIDTH = carouselItem[0].offsetWidth + gap
    const MOVE_DISTANCE = ITEM_OUTER_WIDTH * visibleItem
    const END_POINT = ITEM_OUTER_WIDTH * (carouselItem.length - visibleItem) * -1
    let CURRENT_POSITION = 0

    if (carouselItem.length <= visibleItem) {
      leftCursor?.classList.add(HIDDEN_STYLE_CLASS)
      rightCursor?.classList.add(HIDDEN_STYLE_CLASS)
    }

    if (CURRENT_POSITION === 0 && leftCursor !== null) {
      leftCursor.style.cssText = DISABLED_STYLE
    }

    leftCursor?.addEventListener('click', () => {
      prev()
    })
    rightCursor?.addEventListener('click', () => {
      next()
    })

    function prev() {
      CURRENT_POSITION += MOVE_DISTANCE
      if (CURRENT_POSITION > 0) {
        CURRENT_POSITION = 0
      }
      moveCarousel()
    }

    function next() {
      CURRENT_POSITION -= MOVE_DISTANCE
      if (CURRENT_POSITION < END_POINT) {
        CURRENT_POSITION = END_POINT
      }
      moveCarousel()
    }

    function moveCarousel() {
      toggleCursor()
      if (carouselItems === null) return
      carouselItems.style.transform = `translateX(${CURRENT_POSITION}px)`
    }

    function toggleCursor() {
      if (leftCursor !== null) {
        leftCursor.style.cssText = ''
        if (CURRENT_POSITION === 0) {
          leftCursor.style.cssText = DISABLED_STYLE
        }
      }

      if (rightCursor !== null) {
        rightCursor.style.cssText = ''
        if (CURRENT_POSITION === END_POINT) {
          rightCursor.style.cssText = DISABLED_STYLE
        }
      }
    }
  })
}
